/**
 * The K60 logo — K60's own file, not a redrawing (design 2026-09-27 §4.5).
 *
 * Until K60 sends the vector artwork (AK-1), the files in public/brand/ are
 * cut from the 447-px original by tools/brand/build-brand-assets.py. The mark
 * used to be redrawn in code (K60Mark, deleted with this component); measured
 * against the original it had five faces instead of six and a 22° shear
 * where the original has three 45° bars, each split vertically (GAP-01).
 *
 * Width and height are set on the element from the original's aspect, so the
 * header does not move when the file arrives. The source is 210 px high: any
 * use up to ~100 px still gets real pixels on a 2× screen.
 */

type Variant = "farbig" | "negativ";

const SOURCES: Record<Variant, string> = {
  farbig: "/brand/k60-logo.png",
  negativ: "/brand/k60-logo-negativ.png",
};

/** The same crop at 170 px wide (build-brand-assets.py) — the size a 40 px
 * header slot actually needs on a 2× screen. Without it the full 339-px file
 * was shrunk 5.25× and "GITTERROST SYSTEME" went soft (design §4.5). */
const SMALL_SOURCES: Record<Variant, string> = {
  farbig: "/brand/k60-logo-170.png",
  negativ: "/brand/k60-logo-negativ-170.png",
};

/** Width over height of the trimmed original, 339 × 210 px. */
const ASPECT = 339 / 210;

type K60LogoProps = {
  /** Height in CSS pixels. */
  height: number;
  /** `negativ` for dark surfaces — anthracite panels, photos. */
  variant?: Variant;
  className?: string;
};

export function K60Logo({ height, variant = "farbig", className }: K60LogoProps) {
  const width = Math.round(height * ASPECT);
  return (
    <img
      className={className}
      src={SOURCES[variant]}
      srcSet={`${SMALL_SOURCES[variant]} 170w, ${SOURCES[variant]} 339w`}
      sizes={`${width}px`}
      alt="K60 Gitterrostsysteme"
      height={height}
      width={width}
      decoding="async"
    />
  );
}
